import React from 'react';
import ReactDOM from "react-dom";
import ModalOverlayRLookUp from "../../../Form/ModalOverlayRLookUp";

const RLookUpModal = (props) => {
  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <ModalOverlayRLookUp {...props}/>,
        document.getElementById('overlay-root')
      )}
    </React.Fragment>
  );
};

export default RLookUpModal;
